import { render, staticRenderFns } from "./MiscellaneousForm.vue?vue&type=template&id=c6720f3a&"
import script from "./MiscellaneousForm.vue?vue&type=script&lang=js&"
export * from "./MiscellaneousForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports